export const zIndexLayers = {
  base: 0,
  content: 1,
  chrome: 100,
  floating: 1000,
  popover: 1200,
  modal: 2000,
  modalStacked: 2100,
  modalElevated: 2200,
  modalCritical: 3000,
  userCenter: 3200,
  featureOverlay: 4000,
  guide: 5000,
  devTool: 6100,
  mediaEditor: 9000,
  loading: 10000,
  systemDialog: 12000,
} as const

export type ZIndexLayer = keyof typeof zIndexLayers
